var TscButtonType = {
  cta: 'cta',
  primary: 'primary',
  primaryCamtasia: 'primaryCamtasia',
  primaryScreencast: 'primaryScreencast',
  secondary: 'secondary',
  tertiary: 'tertiary',
  destructive: 'destructive',
  floating: 'floating'
};
export default TscButtonType;